import axios from "axios";
import { IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { trackEvent } from "../../tracking/trackEvent";
import {
  airPriceWatchApi,
  UpdateWatchAlertRequest,
} from "@b2bportal/air-price-watch-api";

export const updateWatch = (
  request: UpdateWatchAlertRequest,
  apiConfig?: IApiConfig
): Promise<unknown> => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await airPriceWatchApi(axios).apiV0AlertWatchUpdatePost(
        request
      );
      resolve(res.data);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });
};
